import { RiAddLine } from '@remixicon/react';
import { type ForwardedRef, forwardRef } from 'react';
import { AgButton } from 'src/components/ui';
import { useLabelAttachmentsStore } from './labelAttachments.store';

type AddLabelButtonProps = { 'data-testid'?: string };

function AddLabelButton({ 'data-testid': dataTestId }: AddLabelButtonProps, ref: ForwardedRef<HTMLButtonElement>) {
  const openDropdown = useLabelAttachmentsStore((state) => state.openDropdown);

  const attachLabelsTo = useLabelAttachmentsStore((state) => state.attachLabelsTo);
  return (
    <AgButton
      variant="white"
      size="xs"
      shape="rounded"
      ref={ref}
      onClick={openDropdown}
      className="ml-1"
      data-testid={dataTestId}
      isDisabled={!attachLabelsTo}
    >
      <RiAddLine size={14} />
    </AgButton>
  );
}

export default forwardRef<HTMLButtonElement, AddLabelButtonProps>(AddLabelButton);
